<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field    
        outlined
        dense
        readonly
        :label="label"
        v-on="on"      
        :value="selectedDate"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="selectedDate"            
      @input="save"
    ></v-date-picker>
  </v-menu>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        default: '',
      },
      value: {
        // Bind the parent's v-model to this prop
        type: String,
        default: "",
      },
    },

    watch: {
      // Update local selectedDate when the parent updates the value prop
      value: {
        immediate: true,
        handler(newValue) {
          this.selectedDate = newValue;
        },
      },
    },

    data: () => ({  
      menu: false,
      selectedDate : '',  // Local data to bind with v-model
    }),

    
    methods: {
      save (date) {      
        this.$emit("input", date);    
        this.menu = false
      }      
    },
  }
</script>